import "core-js/modules/es.array.map";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React from 'react';
import Editor from "../Base/Editor";
import { upperFirst } from "../../utils";
import withGGEditorContext from "../../common/context/GGEditorContext/withGGEditorContext";

var Register =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Register, _React$Component);

  function Register(props, type) {
    var _this;

    _classCallCheck(this, Register);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Register).call(this, props));
    _this.type = type;

    _this.bindEvent();

    return _this;
  }

  _createClass(Register, [{
    key: "bindEvent",
    value: function bindEvent() {
      var _this2 = this;

      var type = this.type;
      var onBeforeAddPage = this.props.onBeforeAddPage;
      onBeforeAddPage(function (_ref) {
        var _host;

        var className = _ref.className;
        var host = Editor[className];
        var keys = ['name', 'config', 'extend'];

        if (type === 'command') {
          host = Editor;
        }

        if (type === 'behaviour') {
          keys = ['name', 'behaviour', 'dependences'];
        }

        var args = keys.map(function (key) {
          return _this2.props[key];
        });

        (_host = host)["register".concat(upperFirst(type))].apply(_host, _toConsumableArray(args));
      });
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Register;
}(React.Component);

Register.create = function (type) {
  var TypedRegister =
  /*#__PURE__*/
  function (_Register) {
    _inherits(TypedRegister, _Register);

    function TypedRegister(props) {
      _classCallCheck(this, TypedRegister);

      return _possibleConstructorReturn(this, _getPrototypeOf(TypedRegister).call(this, props, type));
    }

    return TypedRegister;
  }(Register);

  return withGGEditorContext(TypedRegister);
};

export var RegisterNode = Register.create('node');
export var RegisterEdge = Register.create('edge');
export var RegisterGroup = Register.create('group');
export var RegisterGuide = Register.create('guide');
export var RegisterCommand = Register.create('command');
export var RegisterBehaviour = Register.create('behaviour');